/* eslint-disable react/jsx-filename-extension */
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledSubscription = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 36px;
  gap: 0 16px;

  .header-payment {
    padding: 24px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    .title {
      font-size: 24px;
      font-weight: 700;
      color: ${COLOR.indigo.default};
      line-height: 28px;
      text-transform: uppercase;
    }
  }

  .using-package-list {
    display: grid;
    gap: 16px;
    width: 100%;
    grid-template-rows: auto;
  }

  @media (max-width: 900px) {
    .using-package-list {
      grid-template-columns: repeat(1, minmax(300px, 1fr));
    }
  }

  @media (min-width: 900px) and (max-width: 1500px) {
    .using-package-list {
      grid-template-columns: repeat(2, minmax(300px, 1fr));
    }
  }

  @media (min-width: 1500px) {
    .using-package-list {
      grid-template-columns: repeat(3, minmax(300px, 1fr));
    }
  }
`;

export const StyledSubscriptionV3 = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 36px;
  gap: 0 16px;

  .header-payment {
    padding: 24px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    .title {
      font-size: 24px;
      font-weight: 700;
      color: ${COLOR.indigo.default};
      line-height: 28px;
      text-transform: uppercase;
    }
  }

  .using-package-list {
    display: grid;
    gap: 16px;
    width: 100%;
    grid-template-rows: auto;
  }

  @media (max-width: 1300px) {
    .using-package-list {
      grid-template-columns: repeat(1, minmax(300px, 1fr));
    }
  }

  @media (min-width: 1300px) and (max-width: 1600px) {
    .using-package-list {
      grid-template-columns: repeat(2, minmax(300px, 1fr));
    }
  }

  @media (min-width: 1600px) {
    .using-package-list {
      grid-template-columns: repeat(3, minmax(560px, 1fr));
    }
  }
`;

export const CustomTooltip = styled(({ className, ...props }) => (
  // eslint-disable-next-line react/react-in-jsx-scope
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: COLOR.label[80],
    color: COLOR.white,
    fontSize: 14,
    fontWeight: 400,
    padding: '8px 8px',
    backdropFilter: 'blur(25px)',
    textAlign: 'center',
  },
}));

export const StyledSubscriptionItem = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  border-radius: 16px;
  background-color: ${COLOR.white};
  height: calc(100% - 32px);

  .merge-package-name {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${COLOR.label[16]};
    padding-bottom: 16px;
    .package-name-container {
      display: flex;
      gap: 2px;
      flex-direction: column;
      width: 100%;
      .package-name-text {
        color: ${COLOR.darkGray};
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
        word-wrap: break-word;
      }
      .package-level-duration {
        color: ${COLOR.darkGray};
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        word-wrap: break-word;
      }
    }
    .auto-renewal-container {
      display: flex;
      justify-content: end;
      width: 100%;
      align-items: center;

      .auto-renewal {
        display: flex;
        width: fit-content;
        padding: 4px 10px;
        border-radius: 16px;
        background-color: ${COLOR.indigo[8]};
        font-size: 12px;
        font-weight: 510;
        line-height: 16px;
        letter-spacing: -0.4px;
        color: ${COLOR.darkBlue};
      }
    }
  }

  .package-name {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid ${COLOR.label[16]};
    height: 50px;
    gap: 8px;

    .logo {
      height: 40px;
    }

    .package-name-text {
      display: flex;
      flex-direction: column;

      .name {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        color: ${COLOR.black[80]};
      }

      .auto-renewal {
        display: flex;
        width: fit-content;
        padding: 4px 10px;
        border-radius: 16px;
        background-color: ${COLOR.indigo[8]};
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.4px;
        color: ${COLOR.indigo[100]};
      }
    }
  }

  .margin-bottom-8 {
    margin-bottom: 8px !important;
  }

  .margin-right-2 {
    margin-right: 2px !important;
  }

  .text-16 {
    font-size: 16px !important;
  }

  .underline {
    text-decoration: underline;
  }

  .merge-package-info-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    .expire-date {
      color: ${COLOR.red} !important;
    }

    .font-weight-400 {
      font-weight: 400 !important;
    }

    .label {
      color: ${COLOR.black.default};
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      word-wrap: break-word;
    }

    .content {
      color: ${COLOR.black.default};
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      word-wrap: break-word;
    }

    .package-content {
      display: flex;
      align-items: center;
    }

    .discount-unit-price {
      font-size: 14px;
      font-weight: 400;
      color: ${COLOR.black[80]};
      text-transform: lowercase;
    }
  }

  .icon-container {
    .icon {
      height: 16px;
      width: 16px;
      color: #1e164e7a;
    }
  }

  .package-info-item {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .expire-date {
      color: ${COLOR.red} !important;
    }

    .font-weight-400 {
      font-weight: 400 !important;
    }

    .label {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: ${COLOR.black[80]};
    }

    .content {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: ${COLOR.black[80]};
    }

    .discount-unit-price {
      font-size: 14px;
      font-weight: 400;
      color: ${COLOR.black[80]};
      text-transform: lowercase;
    }
  }

  .character-note {
    color: rgba(28, 28, 30, 0.64);
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    margin-top: -12px;
  }

  .button-group {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .cancel-auto-renewal-btn {
    font-size: 16px;
    font-weight: 700;
    padding: 8px 16px;
    border-radius: 12px;
    text-transform: none;
    color: ${COLOR.indigo.default};
    border: 1px solid ${COLOR.indigo[32]};
    width: 100%;
  }

  .buy-more-btn {
    font-size: 16px;
    font-weight: 700;
    padding: 8px 16px;
    border-radius: 12px;
    text-transform: none;
    background-color: ${COLOR.yellow.default};
    width: 100%;
  }

  .collapse {
    ${(props) =>
      props.showdetail && {
        borderBottom: `1px solid ${COLOR.label[16]}`,
        marginTop: '16px',
      }}
  }
`;
